import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-20 py-16">
        <div className="grid md:grid-cols-12 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_infra-quick/artifacts/jcvhefb8_Picture1.png" 
                alt="Arthaa Build" 
                className="h-16 w-auto mb-6 brightness-0 invert"
              />
            </div>
            <p className="text-slate-500 text-xs uppercase tracking-widest font-semibold mb-3">Building Purpose. Building Prosperity.</p>
            <p className="text-slate-400 leading-relaxed mb-6">
              Technology-forward construction and real estate company delivering world-class precast concrete solutions with purposeful innovation.
            </p>
            <div className="flex gap-3">
              <a href="https://www.linkedin.com/in/arthaa-build-06a6bb402" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-slate-700 hover:border-[#7EB3D8] hover:bg-[#7EB3D8]/10 rounded-md flex items-center justify-center transition-all" aria-label="LinkedIn" data-testid="social-linkedin">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/arthaabuild_" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-slate-700 hover:border-[#7EB3D8] hover:bg-[#7EB3D8]/10 rounded-md flex items-center justify-center transition-all" aria-label="Instagram" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div className="md:col-span-3">
            <h3 className="font-serif font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-400 hover:text-[#7EB3D8] transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/what-is-precast" className="text-slate-400 hover:text-[#7EB3D8] transition-colors">What is Precast</Link>
              </li>
              <li>
                <Link to="/construction" className="text-slate-400 hover:text-[#7EB3D8] transition-colors">Construction Tech</Link>
              </li>
              <li>
                <Link to="/brand-leasing" className="text-slate-400 hover:text-[#7EB3D8] transition-colors">Brand Leasing</Link>
              </li>
              <li>
                <Link to="/property-tech" className="text-slate-400 hover:text-[#7EB3D8] transition-colors">IT & Property Tech</Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-[#7EB3D8] transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-[#7EB3D8] transition-colors">Contact</Link>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div className="md:col-span-4">
            <h3 className="font-serif font-semibold text-lg mb-4">Get In Touch</h3>
            <ul className="space-y-4">
              <li>
                <a href="tel:+917973598780" className="flex items-start gap-3 text-slate-400 hover:text-[#7EB3D8] transition-colors group">
                  <Phone className="w-5 h-5 flex-shrink-0 mt-0.5 group-hover:text-[#7EB3D8]" />
                  <span>+91 79735 98780</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@arthaabuild.com" className="flex items-start gap-3 text-slate-400 hover:text-[#7EB3D8] transition-colors group">
                  <Mail className="w-5 h-5 flex-shrink-0 mt-0.5 group-hover:text-[#7EB3D8]" />
                  <span>info@arthaabuild.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>
                  Industrial Area, Chandigarh<br />
                  Haryana, India - 132103
                </span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
          <p className="text-slate-500">
            © 2026 Arthaa Build. All rights reserved.
          </p>
          <p className="text-slate-600">
            Serving Punjab · Haryana · NCR
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;